import React, { useEffect, useRef, useState } from 'react';
import ReactModal from 'react-modal-resizable-draggable';
import { CirclePicker } from 'react-color';
import useAccessibilityClick from '../../../hooks/useAccessibilityClick';
import '../../../css/Tools.scss';
import { register } from '../../../i18n';
import highlightAnnotationService from '../../services/HighlightAnnotationService';
import useReactModalResizeableDraggable from '../../../hooks/useReactModalResizeableDraggable';
import HighlightAnnotationManager from '../../managers/HighlightAnnotationManager';

const t = register('ToolNames');

function Highlighter() {
  const headerRef = useRef();
  const deleteRef = useRef();
  const underlineRef = useRef();
  const circleRef = useRef();

  const [selectedColor, setSelectedColor] = useState(HighlightAnnotationManager.highlightColor || '#FFF200');

  // Focus on the h2 header when the highlighter dialog opens
  useEffect(() => {
    // Focus on the header after a short delay to ensure the modal is rendered
    setTimeout(() => {
      if (headerRef.current) {
        headerRef.current.focus();
      }
    }, 100);
  }, []);

  useAccessibilityClick(deleteRef, (e) => {
    highlightAnnotationService.deleteSelectedHighlight();
  });

  useAccessibilityClick(underlineRef, (e) => {
    highlightAnnotationService.underlineSelectedHighlight();
  });

  useAccessibilityClick(circleRef, (e) => {
    highlightAnnotationService.circleSelectedHighlight();
  });

  function handleChangeComplete(color, event) {
    highlightAnnotationService.changeColor(color.hex);
    setSelectedColor(color.hex);
  }

  const colors = ['#15FF3C', '#56D4FF', '#FFBBFD', '#FFF200'];
  const circleSize = 25;

  useReactModalResizeableDraggable('colorSelector');

  return (
    <div className='colorSelector'>
      <ReactModal
        className='highlightModal'
        disableResize={true}
        initHeight={75}
        initWidth={280}
        isOpen={true}
        left={5}
        onRequestClose={() => {}}
        role='dialog'
        top={60}>
        <div className='selectorBody'>
          <h2 ref={headerRef} className='title-label basic' tabIndex={-1}>{t('highlightInfo')}</h2>
          <div className='control-container colors' style={{ borderBottom: `7px solid ${selectedColor}` }}>
            <div className='control-section actions'>
              <CirclePicker circleSize={circleSize} colors={colors} onChangeComplete={(color, event) => handleChangeComplete(color, event)} />
            </div>
            <div className='control-section'>
              <button ref={underlineRef} aria-label='underline' className='hatUnderlineButton hatIcon hatControl' />
              <button ref={circleRef} aria-label='circle' className='hatCircleButton hatIcon hatControl' />
              <button ref={deleteRef} aria-label='delete' className='hatDeleteButton hatIcon hatControl' />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default Highlighter;
